export default __webpack_public_path__ + "8eab4398eaae061dfd3fb59a085afd2d.mid";